'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './workorders-code-list.routes';

export class WorkOrderCodeListComponent {
  constructor(Auth, WorkOrderCodesService, dialogs, DTOptionsBuilder, DTState) {
    'ngInject';

    this.WorkOrderCodesService = WorkOrderCodesService;
    this.data = [];

    this.dialogs = dialogs;

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'desc'])
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save())
      .withOption('stateLoadCallback', DTState.restore())
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      .withOption('buttons',[{
        extend: 'excel',
        title: "Work Order Codes"
      },{
        extend: 'csv',
        title: "Work Order Codes"
      },{
        title: "Work Order Codes",
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'portrait',
        pageSize: 'LETTER'
      },{
        extend: 'print',
        title: "Work Order Codes"
      }]);

    this.WorkOrderCodesService.query((data) => {
      this.data = data;
      this.dataInitComplete = true;
    }, err => {
      console.log("Could not retrieve work order codes.")
    });
  }

  delete(code) {
    var that = this;

    var codeText = "<br/><br/><b>" + code.code + ': ' + code.name + "</b><br/><p>" + code.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Work Order Code?", "Do you really want to delete the work order code?" + codeText);
    dlg.result.then(() => {
      // OK delete it
      that.WorkOrderCodesService.delete({id: code._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== code._id;
          });
        },
        err => {
          alert("Could not delete work order code");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduu.workOrderCodeList', [uiRouter])
  .config(routes)
  .component('workOrderCodeList', {
    template: require('./workorders-code-list.html'),
    controller: WorkOrderCodeListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/workorders/code-list/workorders-code-list.component.js